import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.1),
    margin: 0,
    width:'100%'
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const ChipFilter = (prosp) => {
  const {chipData=[], handleDelete} = prosp;
  const classes = useStyles();
  return (
    <Paper component="ul" className={classes.root}>
      {chipData.map((data, index) => {
        let icon;
        return (
          <li key={index}>
            <Chip
              icon={icon}
              label={data.label}
              onDelete={handleDelete(data)}
              className={classes.chip}
            />
          </li>
        );
      })}
    </Paper>
  );
}

export default ChipFilter;